module.exports = __webpack_public_path__ + "img/sword-water-06.df4e375b.png";